<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.transaction[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div class="transaction-container">
					<div class="transaction-provider" :class="{'transaction-provider-active': select == 'deposit'}" @click="changeMethod('deposit')">{{$store.state.lang.text.deposit[$store.state.lang.language]}}</div>
					<div class="transaction-provider" :class="{'transaction-provider-active': select == 'withdraw'}" @click="changeMethod('withdraw')">{{$store.state.lang.text.withdraw[$store.state.lang.language]}}</div>
				</div>
				<!-- <div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="select" @change="changeMethod()">
							  <option value="deposit">ការដាក់ប្រាក់</option>
							  <option value="withdraw">ការដកប្រាក់</option>
						 </select>
					</div>
			  </div> -->
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="deposit in depositList" v-if="select == 'deposit'">
				<div class="deposit-list-menu">
					<div class="deposit-list-header">
						<div class="deposit-left" style="width: 100%">
							#{{deposit.id}}
						</div>
						<div class="deposit-right" style="white-space: nowrap;">
							<span class="green" v-if="deposit.status == 1">{{config.getDepositStatus(deposit.status)}}</span>
							<span class="late" v-if="deposit.status == 0">{{config.getDepositStatus(deposit.status)}}</span>
							<span class="error" v-if="deposit.status == 2">{{config.getDepositStatus(deposit.status)}}</span>
						</div>
					</div>
					<div style="margin-top: 15px">
						<table>
							<tr><td style="padding-right: 30px">{{$store.state.lang.text.deposit_method[$store.state.lang.language]}}</td><td>:</td><td>{{deposit.payment_type}}</td></tr>
							<tr><td>{{$store.state.lang.text.total_amount[$store.state.lang.language]}}</td><td>:</td><td>{{config.moneylify(deposit.amount)}}</td></tr>
							<tr><td>{{$store.state.lang.text.request_date[$store.state.lang.language]}}</td><td>:</td><td>{{config.datelify(deposit.created_date)}}</td></tr>
							<!-- <tr><td>ថ្ងៃអនុម័ត:</td><td>{{deposit.approved_date}}</td></tr>
							<tr><td>ចំណាំ:</td><td>{{deposit.note_user}}</td></tr> -->
						</table>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="withdraw in withdrawList" v-if="select == 'withdraw'">
				<div class="deposit-list-menu">
					<div class="deposit-list-header">
						<div class="deposit-left" style="width: 100%">
							#{{withdraw.id}}

						</div>
						<div class="withdraw-right" style="white-space: nowrap;">
							<span class="green" v-if="withdraw.status == 1">{{config.getWithdrawStatus(withdraw.status)}}</span>
							<span class="late" v-if="withdraw.status == 0">{{config.getWithdrawStatus(withdraw.status)}}</span>
							<span class="error" v-if="withdraw.status == 2">{{config.getWithdrawStatus(withdraw.status)}}</span>
						</div>
					</div>
					<div style="margin-top: 15px">
						<table>
							<tr><td style="padding-right: 30px">{{$store.state.lang.text.withdraw_method[$store.state.lang.language]}}</td><td>:</td><td>{{withdraw.payment_type}}</td></tr>
							<tr><td>{{$store.state.lang.text.total_amount[$store.state.lang.language]}}</td><td>:</td><td>{{config.moneylify(withdraw.amount)}}</td></tr>
							<tr><td>{{$store.state.lang.text.bank_account[$store.state.lang.language]}}</td><td>:</td><td>{{withdraw.account_name}} {{withdraw.account_number}} </td></tr>
							<tr><td>{{$store.state.lang.text.request_date[$store.state.lang.language]}}</td><td>:</td><td>{{config.datelify(withdraw.created_date)}}</td></tr>
							<!-- <tr><td>ថ្ងៃអនុម័ត:</td><td>{{deposit.approved_date}}</td></tr>
							<tr><td>ចំណាំ:</td><td>{{deposit.note_user}}</td></tr> -->
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.changeMethod("deposit");
		},
		methods: {
			getDepositTransaction() {
				this.$http.get(this.config.api + "/user/authed/payment/deposit/get_list").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.depositList = res.body.data;
					}
				})
			},
			getWithdrawTransaction() {
				this.$http.get(this.config.api + "/user/authed/payment/withdraw/get_list").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.withdrawList = res.body.data;
					}
				})
			},
			changeMethod(type) {
				this.select = type
				if(type == "deposit") {
					this.getDepositTransaction();
				} else if (type == "withdraw") {
					this.getWithdrawTransaction();
				}

			}

		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				select: "deposit",
				withdrawList: [],
				depositList: []
			}
		}
	}
</script>
<style>
	.transaction-container {
		display: flex;
		flex-direction: row;
		margin-bottom: 15px;
	}
	.transaction-provider-active {
		background-color: #135F87;
	}
	.transaction-provider {
		cursor: pointer;
		white-space: nowrap;
		margin-right: 8px;
		border: 1px solid #135F87;
		border-radius:15px;
		text-align: center;
		justify-content: center;
		align-items: center;
		padding: 8px 12px;
	}

	.deposit-list-menu {
		cursor:pointer; border-radius: 15px;padding: 14px; margin-bottom: 15px;background-color: var(--secondary-color);

	}
	.deposit-list-header {
		display: flex;
		flex-direction: row;
	}
	.deposit-list-menu-left {
		min-width: calc(30% - 15px) !important;
		max-width: calc(30% - 15px) !important;
		margin-right: 15px !important;
	}
	@media (min-width: 945px) and (max-width: 1264px) {
		.deposit-list-menu-left {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (min-width: 601px) and (max-width: 944px) {
		.deposit-list-menu-left {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 600px) {
		.deposit-list-menu-left {
			min-width: 100% !important;
			max-width: 100% !important;
			margin-right: 0px !important;
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Transaction.vue